export default "__VITE_ASSET__yOuUWcYe__"